import MedicalLeavesView  from '../MedicalLeavesView.vue'
import MedicalLeaveList   from '../Pages/MedicalLeaveList.vue'
import MedicalLeaveCreate from '../Pages/MedicalLeaveCreate.vue'
import MedicalLeaveDetail from '../Pages/MedicalLeaveDetail.vue'

const routes = [
  {
    path: '/descansos-medicos',
    component: MedicalLeavesView,
    children: [
      { path: '',      name: 'medical-leave-list',   component: MedicalLeaveList   },
      { path: 'crear', name: 'medical-leave-create', component: MedicalLeaveCreate },
      { path: ':id',   name: 'medical-leave-detail', component: MedicalLeaveDetail },
    ],
  },
]

export default routes
